<template>
  <div class="user">
    <div class="photo">
      <img
        :src="avatar"
        alt="avatar"
        class="object-cover rounded-full w-[40px] h-[40px]"
      />
    </div>
    <div class="user-info">
      <a
        data-toggle="collapse"
        :aria-expanded="!isClosed"
        @click.stop="toggleMenu"
        @click.capture="clicked"
      >
        <span class="select-none">
          <span
            class="max-w-[60%] block overflow-hidden whitespace-nowrap overflow-ellipsis"
          >
            {{ title }}
          </span>
          <b class="caret"></b>
        </span>
      </a>

      <collapse-transition>
        <div v-show="!isClosed">
          <ul class="nav">
            <slot>
              <li @click="toggleSidebar">
                <router-link :to="myProfile">
                  <span class="sidebar-mini">
                    <i class="fas fa-user-circle icon-color-sidebar"></i>
                  </span>
                  <span class="sidebar-normal">{{
                    $t("sidebar.my_profile")
                  }}</span>
                </router-link>
              </li>
              <li>
                <a href="javascript:void(0)" @click.prevent="logout">
                  <span class="sidebar-mini">
                    <i class="fas fa-sign-out-alt icon-color-sidebar"></i>
                  </span>
                  <span class="sidebar-normal">{{ $t("sidebar.logout") }}</span>
                </a>
              </li>
            </slot>
          </ul>
        </div>
      </collapse-transition>
    </div>
  </div>
</template>
<script>
import { CollapseTransition } from "vue2-transitions";
import Swal from "sweetalert2";
import KeycloakLib from "@/libs/Keycloak";
import { store } from "@/store";
import { removeDeviceToken } from "@/helpers/firebase";
import Role from "@/constants/Role";

export default {
  components: {
    CollapseTransition
  },
  props: {
    title: {
      type: String,
      default: "Tania Andrew"
    },
    rtlTitle: {
      type: String,
      default: "تانيا أندرو"
    },
    avatar: {
      type: String,
      default: "./img/default-avatar.png"
    },
    myProfile: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      isClosed: false,
      Role
    };
  },
  methods: {
    clicked: function(e) {
      e.preventDefault();
    },
    toggleMenu: function() {
      this.isClosed = !this.isClosed;
    },
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    logout: function() {
      Swal.fire({
        title: this.$t("common.are_you_sure"),
        text: this.$t("common.want_to_logout"),
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "md-button md-success btn-fill",
        cancelButtonClass: "md-button md-danger btn-fill",
        confirmButtonText: "Yes",
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          store.dispatch("chat/clearInfoChat");
          removeDeviceToken();
          KeycloakLib.doLogout();
          store.dispatch("schoolAuth/Logout");
        }
      });
    }
  }
};
</script>
<style>
.collapsed {
  transition: opacity 1s;
}
</style>
